import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
  providedIn: 'root'
})
export class TestReportingDataService {
  constructor(private httpClient: HttpClient, private configService: ConfigService) {
  }

  public searchMedtekSendoutTests(start, length, sortBy, sortDirection, medTekFacilityName, medTekLabName, patientName, patientDateOfBirth, medTekCollectionDate, labSerialNumber, gridFilters) {
    var params = `start=${start}&length=${length}&facilityName=${medTekFacilityName}&labName=${medTekLabName}&patientName=${patientName}`;

    if (sortBy) {
      params += `&sortBy=${sortBy}&sortDirection=${sortDirection}`;
    }
    else {
      params += `&sortBy=&sortDirection=`;
    }

    if (labSerialNumber) {
      params += `&labSerialNumber=${labSerialNumber}`;
    }

    if (patientDateOfBirth) {
      params += `&patientDateOfBirth=${this.formatDate(patientDateOfBirth)}`;
    }
    if (medTekCollectionDate) {
      params += `&medTekCollectionDate=${medTekCollectionDate.toLocaleDateString()}`;
    }

    if (gridFilters) {
      params += `&gridFilters=${JSON.stringify(gridFilters)}`;
    }

    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/TestReporting/SearchSendoutTests?${params}`;
    return this.httpClient.get(url);
  }

  public uploadReportDocuments(requisitionId:number, requisitionTestId: number, requisitionTestResultId: number, accession: string, orderTestCode:string, medTek_FacilityCode: string, medTekLab_CLIA: string, documentContentsBase64: string[], appendDocuments: boolean ) {
    var dto =  {
      RequisitionId: requisitionId,
      RequisitionTestId: requisitionTestId,
      RequisitionTestResultId: requisitionTestResultId,
      Accession: accession,
      OrderTestCode: orderTestCode,
      MedTek_FacilityCode: medTek_FacilityCode,
      MedTekLab_CLIA: medTekLab_CLIA,
      DocumentContentsBase64: documentContentsBase64,
      AppendDocuments: appendDocuments

    };

    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/TestReporting/UploadReportDocuments`;
    return this.httpClient.post(url, dto);
  }

  public rejectTest(dto: any) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/TestReporting/RejectTest`;
    return this.httpClient.post(url, dto);
  }

  formatDate(date) {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if(month < 10) {
      month = '0' + month;
    }

    if(day < 10) {
      day = '0' + day;
    }

    return date.getFullYear() + '-' + month + '-' + day;
  }

  //temporary methods for Strand
  public uploadStrandDocument(fileName: string, base64FileContent: string) {
    var dto = {
      FileName: fileName,
      Base64FileContent: base64FileContent
    };

    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Strand/UploadPCRFile`;
    return this.httpClient.post(url, dto);
  }

  public getStrandAccessionFile(fileName: string) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Strand/GetAccessionFile?fileName=${fileName}`;
    return this.httpClient.get(url, { responseType: 'blob' as 'json' });
  }

  //temporary methods for pTau
  public uploadPTauResults(fileName: string, base64FileContent: string) {
    var dto = {
      FileName: fileName,
      Base64FileContent: base64FileContent
    };

    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/PTau/UploadResultFile`;
    return this.httpClient.post(url, dto);
  }

  public getPTauUploadResults(fileName: string) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/PTau/GetUploadResults?fileName=${fileName}`;
    return this.httpClient.get(url);
  }

  public uploadInterVennResults(fileName: string, base64FileContent: string) {
    var dto = {
      FileName: fileName,
      Base64FileContent: base64FileContent
    };

    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/InterVenn/UploadResultFile`;
    return this.httpClient.post(url, dto);
  }

  public getInterVennUploadResults(fileName: string) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/InterVenn/GetUploadResults?fileName=${fileName}`;
    return this.httpClient.get(url);
  }

}
